/* Massform 2026 (draft theme "new layout 2026", 2026-10-21). Loaded as a module, so however many sections
   ask for it, it runs once.

   Wide content that scrolls sideways on a phone, such as the "We did the math" table (Corey: "is there a
   way to make this indicating that the mobile version is scrollable?"). Phones hide their scrollbars, so
   the table read as two columns. It gets a "Swipe to compare" hint until the visitor scrolls, a fade at
   the right edge until the end, a bar showing how far along they are, and one short nudge the first time
   it comes into view (none for visitors who ask for less motion). On a screen wide enough to show it all,
   none of this appears. */
const SCROLLERS = '.comp-scroll-container, .mf-scrollable';
const still = window.matchMedia('(prefers-reduced-motion: reduce)');

function wrap(el) {
  if (el.closest('.mf-scroll')) return;
  const box = document.createElement('div');
  box.className = 'mf-scroll';
  const hint = document.createElement('p');
  hint.className = 'mf-scroll__hint';
  hint.setAttribute('aria-hidden', 'true');
  const words = document.createElement('span');
  words.textContent = el.dataset.mfHint || (el.matches('.comp-scroll-container') ? 'Swipe to compare' : 'Swipe for more');
  const arrow = document.createElement('span');
  arrow.className = 'mf-scroll__arrow';
  arrow.textContent = '→';
  hint.append(words, arrow);
  const view = document.createElement('div');
  view.className = 'mf-scroll__view';
  const bar = document.createElement('div');
  bar.className = 'mf-scroll__bar';
  bar.setAttribute('aria-hidden', 'true');
  const thumb = document.createElement('i');
  bar.append(thumb);
  el.before(box);
  view.append(el);
  box.append(hint, view, bar);

  let nudging = false;
  let frame = 0;
  const update = () => {
    frame = 0;
    const max = el.scrollWidth - el.clientWidth;
    box.classList.toggle('is-scrollable', max > 8);
    if (max <= 8) return;
    const x = Math.min(max, Math.max(0, el.scrollLeft));
    box.classList.toggle('is-end', x >= max - 4);
    if (x > 16 && !nudging) box.classList.add('is-scrolled');
    const part = el.clientWidth / el.scrollWidth;
    thumb.style.width = `${(part * 100).toFixed(2)}%`;
    thumb.style.transform = `translateX(${((x / max) * ((1 - part) / part) * 100).toFixed(2)}%)`;
  };
  const later = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  el.addEventListener('scroll', later, { passive: true });
  // a closed fold has no size; opening it resizes the table, which measures it
  new ResizeObserver(later).observe(el);

  const seen = new IntersectionObserver((entries) => {
    if (!entries.some((e) => e.isIntersecting)) return;
    update();
    if (!box.classList.contains('is-scrollable')) return;
    seen.disconnect();
    if (still.matches || el.scrollLeft > 0) return;
    nudging = true;
    setTimeout(() => {
      el.scrollTo({ left: 64, behavior: 'smooth' });
      setTimeout(() => {
        el.scrollTo({ left: 0, behavior: 'smooth' });
        setTimeout(() => { nudging = false; }, 700);
      }, 650);
    }, 400);
  }, { threshold: 0.5 });
  seen.observe(el);
}

document.querySelectorAll(SCROLLERS).forEach(wrap);
// the theme editor re-renders a section in place when it is changed
document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll(SCROLLERS).forEach(wrap));
